import { isAxiosError } from 'axios'

import httpClient from '../../httpClient.ts'
import { FetchResponse, PrepaidVoucherPostData } from './types.ts'

const getList = async <T>(
  params: string | undefined
): Promise<FetchResponse<T>> => {
  const fetchResponse: FetchResponse<T> = {
    data: null,
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.get<T>(
      `/api/dd_panel_prepaid_vouchers/${params}`
    )
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data.error_code
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

const getDetails = async <T>(
  voucherId: number
): Promise<FetchResponse<T>> => {
  const fetchResponse: FetchResponse<T> = {
    data: null,
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.get<T>(
      `/api/dd_panel_prepaid_vouchers/${voucherId}`
    )
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data.error_code
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

const createVoucher = async <T>(
  data: PrepaidVoucherPostData
): Promise<FetchResponse<T>> => {
  const fetchResponse: FetchResponse<T> = {
    data: null,
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.post<T>(
      '/api/dd_panel_prepaid_vouchers/',
      data
    )
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data.error_code
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

const updateVoucher = async <T>(
  voucherId: number,
  data: PrepaidVoucherPostData
): Promise<FetchResponse<T>> => {
  const fetchResponse: FetchResponse<T> = {
    data: null,
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.put<T>(
        `/api/dd_panel_prepaid_vouchers/${voucherId}/`,
      data
    )
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data.error_code
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

export const prepaidVouchersApi = {
  getList,
  getDetails,
  createVoucher,
  updateVoucher
}
